import { MenuItem, Popover } from "@material-ui/core";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Spin } from "antd";
import {
   accountSummaryBlue,
   loginInfoBlue,
   logoutBlue,
   paymentInfoBlue,
   profileInfoBlue
} from "../../../../../app/assets/icons";
import { useTranslation } from "../../../../../app/i18n/LanguageContext";
import AuthService from "../../../../../app/base/services/authentication.service";
import { switchRole } from "../../../../../app/base/services/role.service";
import {
   getRoleLandingPath,
   translateRoleName,
   UserRolesEnum
} from "../../../../../app/pages/auth/userRoles.enum";
import Toast from "../../../../../app/base/components/Toast";

const PopoverLinks = ({ anchorEl, handleClose, logout, isSuperAdmin, isNgo }) => {
   const { t } = useTranslation();
   const [switchingTo, setSwitchingTo] = useState(null);

   // An account can hold more than one role (e.g. Expert + Approver) but a
   // session only ever runs under one of them. Single-role accounts see nothing
   // of this - the switcher is not rendered at all.
   const roles = AuthService.getRoles();
   const activeRoleName = AuthService.getActiveRoleName();
   const otherRoles = roles.filter((role) => role?.name !== activeRoleName);
   const canSwitchRole = roles.length > 1 && otherRoles.length > 0;

   const handleSwitchRole = async (roleName) => {
      if (switchingTo) return;
      setSwitchingTo(roleName);

      try {
         const response = await switchRole(roleName);
         AuthService.setSession(response?.data);

         // The visible app changes completely between roles - route guards, menus
         // and every role-scoped fetch are evaluated off the stored active role.
         // A full load of the new landing page is the one way to be sure none of
         // them is left holding the old role's data.
         window.location.href = getRoleLandingPath(AuthService.getActiveRoleName());
      } catch (error) {
         Toast.error(
            error?.response?.data?.errors?.[0]?.message || t("switch-role-error-description")
         );
         setSwitchingTo(null);
      }
   };
   return (
      <Popover
         id="simple-popover"
         className="popOver_account"
         open={Boolean(anchorEl)}
         anchorEl={anchorEl}
         onClose={handleClose}
         style={{
            position: "fixed",
            top: "50px"
            // left: "-40px"
         }}
         PaperProps={{
            style: {
               borderRadius: "8px",
               width: "220px"
            }
         }}
      >
         {canSwitchRole && (
            <>
               <div className="role-switcher">
                  <div className="role-switcher-title">{t("switch-role-label")}</div>
                  <div className="role-switcher-active">
                     {translateRoleName(activeRoleName, t)}
                     <span>{t("current-role-label")}</span>
                  </div>
                  {otherRoles.map((role) => (
                     <MenuItem
                        key={role?.id || role?.name}
                        className="role-switcher-option"
                        disabled={Boolean(switchingTo)}
                        onClick={() => handleSwitchRole(role?.name)}
                     >
                        <span>{translateRoleName(role?.name, t)}</span>
                        {switchingTo === role?.name && <Spin size="small" />}
                     </MenuItem>
                  ))}
               </div>
               <div className="devider"></div>
            </>
         )}
         {isSuperAdmin || isNgo ? (
            <Link to={isSuperAdmin ? `/admin/account-summary` : isNgo && `/account-summary`}>
               <MenuItem>
                  <img src={accountSummaryBlue} alt={t("account-summary-icon-alt")} />
                  <span>{t("account-summary-label")}</span>
               </MenuItem>
            </Link>
         ) : null}
         {/* Profile information hidden for organization, manager and staff roles (they use the Profile page in the left panel). */}
         {!AuthService.isAuthorized([
            UserRolesEnum.NationalOrganization,
            UserRolesEnum.InternationalOrganization,
            UserRolesEnum.Manager,
            UserRolesEnum.Staff
         ]) && (
            <Link to={isSuperAdmin ? `/admin/profile-information` : `/profile-information`}>
               <MenuItem>
                  <img src={profileInfoBlue} alt={t("profile-info-icon-alt")} />
                  <span>{t("profile-information-label")}</span>
               </MenuItem>
            </Link>
         )}
         <Link to={isSuperAdmin ? `/admin/login-information` : `/login-information`}>
            <MenuItem>
               <img src={loginInfoBlue} alt={t("login-info-icon-alt")} />
               <span>{t("login-information-label")}</span>
            </MenuItem>
         </Link>
         {isSuperAdmin && (
            <Link to="/admin/payment-information">
               <MenuItem>
                  <img src={paymentInfoBlue} alt={t("payment-info-icon-alt")} />
                  <span>{t("payment-information-label")}</span>
               </MenuItem>
            </Link>
         )}
         <div className="devider"></div>
         <Link to="/auth">
            <MenuItem onClick={logout}>
               <img src={logoutBlue} alt={t("log-out-icon-alt")} />
               <span>{t("log-out-button")}</span>
            </MenuItem>
         </Link>
      </Popover>
   );
};
export default PopoverLinks;
